import { useContext } from "react";
import { FormulaFlowContext } from "./FormulaFlowContext";

export const useFormulaFlow = () => {
  const context = useContext(FormulaFlowContext);

  if (!context) {
    throw new Error("useFormulaFlow must be used inside FormulaFlowProvider");
  }

  return context;
};
